import React, { useState, useEffect } from "react";
import { Card, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from "../../auth/auth";
import { useIsAuthenticated } from "@azure/msal-react";
import '../../styles/Home.css';

export const Home = () => {
    const { getRoles } = useAuth();
    const isAuthenticated = useIsAuthenticated();
    const [availableTools, setAvailableTools] = useState([]);

    const tools = [
        {
            id: 'tap',
            title: 'Temporary Access Pass',
            description: 'Generate temporary access passes for users to authenticate without their primary credentials.',
            route: '/tap',
            roles: ['MFA.TAP.CREATE']
        },
        {
            id: 'mfa',
            title: 'MFA Method Detail',
            description: 'View and manage multi-factor authentication methods for user accounts.',
            route: '/mfa',
            roles: ['MFA.Read', 'MFA.ReadWrite', 'MFA.Read.All', 'MFA.ReadWrite.All']
        },
        {
            id: 'mfaBulk',
            title: 'MFA Bulk Upload',
            description: 'Upload and configure MFA methods for multiple users at once.',
            route: '/mfaBulk',
            roles: ['MFA.BulkUpload']
        },
        {
            id: 'signInActivity',
            title: 'Sign-In Activity',
            description: 'Monitor and review user sign-in activity and authentication logs.',
            route: '/signInActivity',
            roles: ['KibanaLogs.Read']
        },
        {
            id: 'summerrainUsers',
            title: 'Summerrain Test Users',
            description: 'Manage test user accounts in the Summerrain environment.',
            route: '/summerrainUsers',
            roles: ['Summerrain.ReadWrite']
        },
        {
            id: 'b2cSignInEvents',
            title: 'B2C Sign-In Events',
            description: 'Search and review B2C sign-in event logs and troubleshoot authentication issues.',
            route: '/b2cSignInEvents',
            roles: ['B2C.SignInLogs.Read']
        },
        {
            id: 'adLockout',
            title: 'AD Lockouts',
            description: 'View and troubleshoot Active Directory account lockout events.',
            route: '/adLockout',
            roles: ['KibanaLogs.Read', 'KibanaLogs.Read.LockOuts']
        },
        {
            id: 'tou',
            title: 'B2C TOU',
            description: 'Manage and reset Terms of Use acceptance for B2C users.',
            route: '/tou',
            roles: ['B2C.Read', 'B2C.ReadWrite', 'B2C.TOU.Reset']
        },
        {
            id: 'sharepointPermissions',
            title: 'SharePoint Permissions Lookup',
            description: 'View and manage SharePoint site permissions and access controls.',
            route: '/sharepointPermissions',
            roles: ['SharePoint.ReadWrite']
        },
        {
            id: 'activityLog',
            title: 'Activity Log',
            description: 'View and search Identity portal log activity.',
            route: '/activityLog',
            roles: ['MFA.AuditLog.Read', 'MFA.Read.All', 'MFA.ReadWrite.All']
        },
        {
            id: 'appRegistration',
            title: 'Create App Registration',
            description: 'Create a new app registration and enterprise application with you as the owner.',
            route: '/appRegistration',
            roles: ['AppRegistration.Create']
        },

    ];

    useEffect(() => {
        const checkRoles = async () => {
            if (!isAuthenticated) {
                setAvailableTools([]);
                return;
            }

            const tokenRoles = await getRoles();
            const filtered = tools.filter(tool => 
                tool.roles.some(role => tokenRoles.includes(role))
            );
            setAvailableTools(filtered);
        };

        checkRoles();
    }, [isAuthenticated]);

    return (
        <Container className="home-container">
            <br />
            <Row className="g-4">
                {availableTools.map(tool => (
                    <Col key={tool.id} xs={12} md={6} lg={4}>
                        <Link to={tool.route} className="tool-card-link">
                            <Card className="tool-card h-100">
                                <Card.Body>
                                    <Card.Title>{tool.title}</Card.Title>
                                    <Card.Text>{tool.description}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Link>
                    </Col>
                ))}
            </Row>
            {availableTools.length === 0 && isAuthenticated && (
                <p className="no-tools-message">No tools available. Please contact your administrator for access.</p>
            )}
        </Container>
    );
};
